import React, { FC } from 'react';
import { Colors } from '../../../../styles/colors';

interface Props {
  color: string;
}

export const ProductIconDigitaleWohnungsuebergabe: FC<Props> = ({ color = Colors.white }) => {
  return (
    <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 118.9 117.4" style={{ color }} xmlSpace="preserve" fill="currentColor">
      <path d="M19.4,65.4c5.4,0,9.8,4.4,9.8,9.8c0,2.6-1,5.1-2.9,6.9C24.5,84,22,85,19.4,85l0,0c-5.4-0.2-9.6-4.7-9.5-10.1
        C10.1,69.7,14.3,65.6,19.4,65.4L19.4,65.4z M19.4,80.2L19.4,80.2c2.8,0,5.1-2.3,5.1-5.1c0-2.8-2.3-5.1-5.1-5.1
        c-2.8,0-5.1,2.3-5.1,5.1l0,0C14.4,78,16.6,80.2,19.4,80.2L19.4,80.2z"/>
            <path d="M0.5,83.3l11.7-30.1c0.2-0.6,0.7-1,1.2-1.3l11.3-5.1c1.3-4.9,5.4-9.9,13-9c3.6,0.4,6.8,2.4,8.6,5.5
        c7.1,1.5,11.8,8.4,10.3,15.6c-0.4,1.8-1.1,3.5-2.1,4.9l2.5,6.7c0.2,0.6,0.2,1.2-0.1,1.8c-0.3,0.6-0.7,1-1.3,1.2L54.1,74l0.5,1.3
        l1.7-0.6c1.2-0.4,2.5,0.1,3,1.3l2.6,6.2c0.2,0.6,0.2,1.3,0,1.8c-0.3,0.6-0.7,1-1.3,1.3l-1.7,0.6l0.2,0.4l0.7-0.3
        c1.2-0.4,2.6,0.2,3,1.4l1.8,4.7c0.2,0.7,0.2,1.4-0.2,2l-3.1,5.7c-0.4,0.8-1.2,1.2-2.1,1.2c-0.3,0-0.7-0.1-1-0.2l-5.9-2.6
        c-0.6-0.3-1-0.7-1.2-1.3L40.4,69c-0.9-0.2-1.7-0.5-2.5-0.9L26.4,97.9c-0.5,1.2-1.7,1.8-2.9,1.4L5,93.1C1,91.6-0.9,87.2,0.5,83.3z
         M35.7,59.2c1.1,2.9,3.6,5,6.7,5.5c0.8,0.1,1.5,0.7,1.8,1.5l11,28.1l3,1.3l1.6-2.8l-0.6-1.5l-0.7,0.2c-1.2,0.4-2.5-0.2-3-1.3
        l-1.9-4.8c-0.2-0.6-0.2-1.2,0-1.8c0.3-0.6,0.7-1,1.3-1.2l1.6-0.6L55.7,80l-1.8,0.7c-1.2,0.4-2.6-0.2-3-1.4l-2-5.7
        c-0.4-1.2,0.2-2.6,1.4-3l1.4-0.6l-2.1-5.7c-0.3-0.8-0.1-1.7,0.4-2.4c3.1-3.5,2.8-8.9-0.7-12l0,0c-0.4-0.4-0.8-0.7-1.3-1
        c0.1,1.2,0,2.5-0.3,3.7c1.9,2.1,1.8,5.4-0.2,7.4c-1,1-2.3,1.5-3.7,1.5c-2.9,0-5.3-2.5-5.2-5.4c0-2.7,2.1-4.9,4.7-5.2
        c0.1-1,0.1-2.1-0.2-3.1c-4.7,0.3-8.2,4.4-7.8,9.1C35.3,57.7,35.5,58.5,35.7,59.2z M40.2,43.6c-0.9-0.6-2-1-3.1-1.1
        c-2.3-0.4-4.6,0.3-6.2,2.1c0.6,0.2,1.1,0.6,1.4,1.1l1.2,2.1c0.1-0.1,0.1-0.1,0.2-0.2C35.5,45.6,37.8,44.3,40.2,43.6z M6.5,88.6
        l16.3,5.5L34,65.2c-1.1-1.2-2-2.6-2.6-4.2c-1.9-0.8-3.5-2.1-4.7-3.7l-0.3-0.1c-1.7-0.6-2.5-2.5-1.9-4.2s2.5-2.5,4.2-1.9
        c0.1,0,0.1,0,0.2,0.1c1,0.4,1.7,1.3,1.9,2.3c0.1-0.3,0.2-0.7,0.2-1l-1.6-2.8l-13.2,6L4.9,85C4.4,86.4,5.1,88.1,6.5,88.6z"/>
            <path d="M36.6,108.7c0,2.2,1.8,4,4,4h69.6c2.2,0,4-1.8,4-4V15.1H36.6v21.4h-4.7V8.7c0-4.8,3.9-8.7,8.7-8.7h69.6
        c4.8,0,8.7,3.9,8.7,8.7v100c0,4.8-3.9,8.6-8.7,8.7H40.5c-4.8,0-8.6-3.9-8.7-8.6V93.1h4.7L36.6,108.7L36.6,108.7z M110.2,4.7H40.5
        c-2.2,0-4,1.8-4,4v1.8h77.7V8.7C114.2,6.5,112.4,4.7,110.2,4.7z"/>
    </svg>
  );
};
